export default __webpack_public_path__ + "static/media/imageicone.e7e6b7aa.png";